import { useCallback } from "react";
import apiClient2 from "../../api/apiClient2";
import apiPaths from "../../api/endpoints";

export interface ColourSheet {
  image: string;
  [key: string]: any;
}

/**
 * Mirrors srcMobile/Screens/FunBoxScreen/Doodling/useDoodling.tsx
 * - postDoodleData → POST /v3/captureDoodle (multipart/form-data)
 * - fetchColourSheets → GET /getDoodles → returns ColourSheet[]
 */
export function useDoodling() {
  const postDoodleData = useCallback(async (formData: FormData) => {
    try {
      const response = await apiClient2.post(apiPaths.POST_DOODLE, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return response;
    } catch (err: any) {
      console.error("postDoodleData error:", err);
      return err;
    }
  }, []);

  const fetchColourSheets = useCallback(async (): Promise<ColourSheet[]> => {
    try {
      const response = await apiClient2.get(apiPaths.GET_COLOUR_SHEETS);
      return response.data?.data ?? response.data ?? [];
    } catch (err: any) {
      console.error("fetchColourSheets error:", err);
      return [];
    }
  }, []);

  return { postDoodleData, fetchColourSheets };
}
